import { Link } from "gatsby"
import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { TranslationContainer } from "../containers"
import styles from "./404.module.less"

const NotFoundPage: React.FC = ({}) => {
  const { translate } = TranslationContainer.useContainer();
  return (
    <Layout>
      <SEO title="404: Not found" />
      <div className={styles.p404Wrapper}>
        <div className={styles.p404}>
          <h1 className={styles.title}>{`404: ${translate("notFound.notFound")}`}</h1>
          <p className={styles.message}>
            <b>{`${translate("notFound.routeDoesNotExists")} :(`}</b>
          </p>
          <Link to="/">{translate("notFound.returnToSafePlace")}</Link><br />
        </div>
      </div>
    </Layout>)
}

export default NotFoundPage
